module.exports = __webpack_public_path__ + "assets/img/apple.1bb28b77.svg";